<template>
  <div class="d-flex flex-column">
    <span :class="`text-${text}`" class="text-xl font-weight-bold"
      >Passwort:</span
    >
    <div>
      <input
        type="password"
        v-model="password"
        class="password"
        @input="calcPasswordStrength()"
        required
      />
      <SquareButton @click.native="select">-></SquareButton>
    </div>
    <div class="row" :class="`text-${text}`">
      Passwortstärke:&nbsp;
      <span v-if="passwordStrength == 3">sehr stark</span>
      <span v-if="passwordStrength == 2">stark</span>
      <span v-if="passwordStrength == 1">mittel</span>
      <span v-if="passwordStrength == 0">schwach</span>
    </div>
    <div
      v-if="passwordStrength == 3"
      class="row shadow-sm password-bar password-very-strong"
    ></div>
    <div
      v-if="passwordStrength == 2"
      class="row shadow-sm password-bar password-strong"
    ></div>
    <div
      v-if="passwordStrength == 1"
      class="row shadow-sm password-bar password-medium"
    ></div>
    <div
      v-if="passwordStrength == 0"
      class="row shadow-sm password-bar password-weak"
    ></div>
    <div v-if="hasErrors" class="row">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          <span v-for="(error, index) in errors.errors.password" :key="index">{{
            error
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
input {
  height: 60px;
  border-radius: 10px;
  border: 1px solid black;

  padding: 8px;

  margin-right: 8px;
}

.password-bar {
  height: 5px;
}

.password-weak {
  width: 55%;
  background-color: $red;
}
.password-medium {
  width: 70%;
  background-color: $yellow;
}
.password-strong {
  width: 85%;
  background-color: $light-green;
}
.password-very-strong {
  width: 100%;
  background-color: $green;
}
</style>

<script>
import SquareButton from "./SquareButton.vue";

export default {
  props: {
    errors: {
      type: Object,
      default: null
    },
    text: {
      type: String,
      default: "white"
    }
  },
  components: {
    SquareButton
  },
  data() {
    return {
      password: null,
      passwordStrength: 0
    };
  },
  computed: {
    hasErrors() {
      return this.errors !== null;
    }
  },
  methods: {
    select() {
      this.$emit("input", this.password);
    },
    calcPasswordStrength() {
      let pwStr,
        pwChars = 0;

      if (/[0-9]/.test(this.password)) {
        pwChars += 10;
      }
      if (/[a-z]/.test(this.password)) {
        pwChars += 26;
      }
      if (/[A-Z]/.test(this.password)) {
        pwChars += 26;
      }
      if (/[^A-Za-z0-9]/.test(this.password)) {
        pwChars += 30;
      }

      pwStr = Math.pow(pwChars, this.password.length);

      if (pwStr > Math.pow(10, 21)) this.passwordStrength = 3;
      else if (pwStr > Math.pow(10, 15)) this.passwordStrength = 2;
      else if (pwStr > Math.pow(10, 9)) this.passwordStrength = 1;
      else this.passwordStrength = 0;
    }
  }
};
</script>
